import { render, staticRenderFns } from "./TableActionAddRenderer.vue?vue&type=template&id=ff9a0dd4&"
import script from "./TableActionAddRenderer.vue?vue&type=script&lang=ts&"
export * from "./TableActionAddRenderer.vue?vue&type=script&lang=ts&"
import style0 from "./TableActionAddRenderer.vue?vue&type=style&index=0&id=ff9a0dd4&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports